import React from 'react'
import styled from 'styled-components'
import Grid from '../components/Grid/Grid'

const Projectspage = () => {
    return (
        <Gallery>
            <Grid />
        </Gallery>
    )
}

const Gallery = styled.div`
    min-height: 100vh;
    width: 100%;
    background-color: #191919;
`;

export default Projectspage
